/**
 * Statuts officiels d’une **instance** d’intervention joueur (API + UI).
 *
 * Persistance MySQL (enum actuel) : `DISPONIBLE` | `EN_COURS` | `TERMINEE` | `ANNULEE`.
 * Tant que la colonne n’est pas migrée, le serveur continue d’écrire ces valeurs ;
 * en lecture, on expose uniquement les 4 statuts canoniques ci-dessous.
 */

export type InterventionInstanceStatutApi =
  | 'EN_ATTENTE'
  | 'EN_COURS'
  | 'TERMINE'
  | 'ANNULE';

function stripAccents(s: string): string {
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Convertit tout ancien libellé (ou valeur inconnue) vers les 4 statuts officiels.
 * - TERMINEE* / TERMINE / TERMINÉE… → TERMINE
 * - ANNULEE / ANNULE / ANNULÉE… → ANNULE
 * - DISPONIBLE / WAITING / EN_ATTENTE → EN_ATTENTE
 * - EN_COURS, EN_ROUTE, SUR_LIEU (instance) → EN_COURS
 * - défaut → EN_ATTENTE (affichage prudent)
 */
export function normalizeInterventionInstanceStatut(raw: string): InterventionInstanceStatutApi {
  const u = stripAccents(String(raw ?? '').trim()).toUpperCase();

  if (u === 'ANNULE' || u === 'ANNULEE') return 'ANNULE';
  if (u === 'TERMINE' || u === 'TERMINEE' || u === 'TERMINEE_SUCCES' || u === 'TERMINEE_ECHEC') {
    return 'TERMINE';
  }
  if (u.startsWith('TERMINEE')) return 'TERMINE';

  if (u === 'EN_ATTENTE' || u === 'DISPONIBLE' || u === 'WAITING') return 'EN_ATTENTE';
  if (u === 'EN_COURS' || u === 'EN ROUTE' || u === 'EN_ROUTE' || u === 'SUR_LIEU' || u === 'SUR LIEU') {
    return 'EN_COURS';
  }

  return 'EN_ATTENTE';
}

export function isTerminalInterventionInstanceStatutApi(s: InterventionInstanceStatutApi): boolean {
  return s === 'TERMINE' || s === 'ANNULE';
}

export function isTerminalInterventionInstanceStatutRaw(raw: string): boolean {
  return isTerminalInterventionInstanceStatutApi(normalizeInterventionInstanceStatut(raw));
}
